import React, { createContext, useState, useContext } from 'react';

const MouseContext = createContext();

export const MouseProvider = ({ children }) => {
  const [mousePosition, setMousePosition] = useState({ x: window.innerWidth / 2, y: window.innerHeight / 2 });

  return (
    <MouseContext.Provider value={{ mousePosition, setMousePosition }}>
      {children}
    </MouseContext.Provider>
  );
};

export const useMousePosition = () => {
  const context = useContext(MouseContext);
  if (!context) {
    throw new Error('useMousePosition must be used within a MouseProvider');
  }
  return context;
};
